// apilinks.js
const ApiLinks = {
   login: 'users/Login',
   // Amenties
   Amenties: 'amenties/GetAll',
   Amenties_Delete: 'amenties/Delete',
   Amenties_GetById: 'amenties/GetById',
   Amenties_Save: 'amenties/Add',
   Amenties_Update: 'amenties/Update',
   // Amenties
   Developer: 'developer/GetAll',
   Developer_Delete: 'developer/Delete',
   Developer_GetById: 'developer/GetById',
   Developer_Save: 'developer/Add',
   Developer_Update: 'developer/Update',
   // Category
   Category: 'category/GetAll',
   Category_Delete: 'category/Delete',
   Category_GetById: 'category/GetById',
   Category_Save: 'category/Add',
   Category_Update: 'category/Update',
   // State
   State_list: 'state/GetAll',
   State_Delete: 'state/Delete',
   State_GetById: 'state/GetById',
   State_Save: 'state/Add',
   State_Update: 'state/Update',
   //
   // State
   City_list: 'city/GetAll',
   City_Delete: 'city/Delete',
   City_GetById: 'city/GetById',
   City_Save: 'city/Add',
   City_Update: 'city/Update',

   // Projects
   ProjectOverview_list: 'property/GetAll',
   ProjectOverview_GetById: 'property/GetById',
   ProjectOverview_Update: 'property/Update',
   ProjectOverview_Save: 'property/Add',
   ProjectOverview_Delete: 'property/Delete',
   ProjectOverview_Patch: 'property/PatchProperty',


   // FloorPlan
   FloorPlan_list: 'property/AddFloorPlan',
   FloorPlan_GetById: 'property/GetFloorPlanById',
   FloorPlan_Save: 'property/AddFloorPlan',
   FloorPlan_Delete: 'property/DeleteFloorPlan',

   //PropertyImages
   PropertyImages_GetById: 'property/GetPropertyImagesById',
   PropertyImages_Delete: 'property/DeletePropertyImages',
   PropertyImages_Save: 'property/AddPropertyImages',

   // Enquiry
   Enquiry_list: 'enquiry/GetAll',
   Enquiry_Delete: 'enquiry/Delete',


   // banner
   Banner_list: 'banner/GetAll',
   Banner_GetById: 'banner/GetById',
   Banner_Update: 'banner/Update',



};

export default ApiLinks;
